// Anti-abuse risk rules (roadmap P1-D20). `game` rules are raised by he A (backend
// lib/chong_lam_dung.js, lib/hai_cua.js, lib/nhip_cuoc.js); `cms` rules by the CMS worker
// (apps/api/src/jobs/risk.ts). `mark` = the CMS risk mark a 'co' action sets on the player.
export const RISK_RULES = {
    dang_ky_thiet_bi: { label: 'Nhiều tài khoản đăng ký từ một thiết bị', mark: 'suspectedMulti' },
    dang_ky_ip: { label: 'Nhiều tài khoản đăng ký từ một IP', mark: 'suspectedMulti' },
    dang_nhap_thiet_bi: { label: 'Nhiều tài khoản đăng nhập trên một thiết bị', mark: 'suspectedMulti' },
    thuong_trung: { label: 'Nhận thưởng tân thủ lần hai (cùng thiết bị / ngân hàng)', mark: 'suspectedMulti' },
    hai_cua: { label: 'Cược hai cửa đối nhau trong một ván', mark: 'watchlist' },
    cap_hai_cua: { label: 'Hai tài khoản liên kết cược hai cửa đối nhau', mark: 'suspectedMulti' },
    sai_dang_nhap: { label: 'Sai mật khẩu nhiều lần', mark: 'watchlist' },
    nap_rut_it_choi: { label: 'Nạp rồi rút mà chơi ít', mark: 'watchlist' },
    thiet_bi_moi_rut: { label: 'Rút tiền từ thiết bị mới', mark: 'suspectedMulti' },
    cuoc_qua_nhanh: { label: 'Đặt cược quá nhanh (công cụ)', mark: 'suspectedBot' },
    cuoc_giay_cuoi: { label: 'Hay cược ở giây cuối (công cụ)', mark: 'suspectedBot' },
    nhip_deu: { label: 'Nhịp cược đều bất thường (công cụ)', mark: 'suspectedBot' },
    thang_lon: { label: 'Thắng lớn', mark: 'watchlist' },
    chuoi_thang: { label: 'Chuỗi thắng dài', mark: 'watchlist' },
    ty_le_thang: { label: 'Tỷ lệ thắng vượt xa kỳ vọng', mark: 'watchlist' },
    dai_ly: { label: 'Thành viên chung thiết bị / ngân hàng với đại lý', mark: 'suspectedMulti' },
};
export const RISK_ACTION_LABEL = {
    giu_rut: 'Giữ rút tiền',
    co: 'Gắn cờ',
    bao: 'Báo Telegram',
};
export const riskRuleLabel = (rule) => RISK_RULES[rule]?.label ?? rule;
export const riskMarkOf = (rule) => RISK_RULES[rule]?.mark ?? 'watchlist';
//# sourceMappingURL=risk.js.map